import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad gäller om det inträffar våld på serveringsstället?";
const SHORT_ANSWER = "Du ska polisanmäla, dokumentera händelsen och vidta åtgärder för att förebygga upprepning. Återkommande våld leder till varning eller återkallelse.";

export const Route = createFileRoute("/fraga/vad-galler-vid-vald-pa-stallet")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad gäller om det inträffar våld på serveringss…" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Vid allvarliga händelser kan polisen och kommunen kräva ordningsvakter eller tidigare stängning. Försäkringsbolag kan höja premier eller avsluta avtal."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/alkohollagen-kapitel-8", label: "Ordningsfrågor och tillsyn" }}
      related={[{"to": "/fraga/ar-id-kontroll-obligatorisk", "label": "Är ID-kontroll obligatorisk vid alkoholservering?"}, {"to": "/fraga/far-jag-neka-en-gast-tilltrade", "label": "Får jag neka en gäst tillträde till restaurangen?"}, {"to": "/fraga/vad-galler-vid-misstankt-narkotikahandel", "label": "Vad gäller om jag misstänker narkotikahandel i lokalen?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad gäller om det inträffar våld på serveringsstället?" },
      { name: "description", content: "Du ska polisanmäla, dokumentera händelsen och vidta åtgärder för att förebygga upprepning. Återkommande våld leder till varning eller återkallelse." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-galler-vid-vald-pa-stallet" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-galler-vid-vald-pa-stallet" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-galler-vid-vald-pa-stallet",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad gäller om det inträffar våld på serveringss…", url: "https://alkoholprovet.se/fraga/vad-galler-vid-vald-pa-stallet" },
      ]),
    ],
  }),
});
